// components/ContactModal.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { X, MessageCircle, Send, ExternalLink } from 'lucide-react';
import { Card } from './ui';

export const ContactModal = ({ isOpen, onClose, title }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-[200] bg-gray-50/80 backdrop-blur-xl flex items-center justify-center p-6 animate-in fade-in duration-300">
      <Card size="lg" className="w-full max-w-sm rounded-[3.5rem]">
        <button onClick={onClose} className="absolute top-8 right-8 text-gray-400 hover:text-gray-900 transition-colors">
          <X size={20} />
        </button>
        <div className="text-center space-y-6">
          <div className="inline-flex p-4 bg-brand-accent-muted text-red-600 rounded-2xl mb-2">
            <MessageCircle size={32} />
          </div>
          <h3 className="text-xl font-black text-gray-900 uppercase italic tracking-tight">{title}</h3>
          <p className="text-sm text-gray-500 italic">{t('ContactModal.choose_contact_method')}</p>
          <div className="space-y-3">
            <a
              href="https://t.me/isv_soc_bot"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-between w-full p-5 bg-sky-500/10 border border-sky-500/20 rounded-3xl text-sky-400 font-bold hover:bg-sky-500 hover:text-gray-900 transition-all group"
            >
              <span className="flex items-center gap-3"><Send size={18} /> Telegram</span>
              <ExternalLink size={14} className="opacity-0 group-hover:opacity-100" />
            </a>
            <a
              href="https://wa.me/77770000000"
              target="_blank"
              rel="noreferrer"
              className="flex items-center justify-between w-full p-5 bg-emerald-500/10 border border-emerald-500/20 rounded-3xl text-emerald-400 font-bold hover:bg-emerald-500 hover:text-gray-900 transition-all group"
            >
              <span className="flex items-center gap-3"><MessageCircle size={18} /> WhatsApp</span>
              <ExternalLink size={14} className="opacity-0 group-hover:opacity-100" />
            </a>
          </div>
        </div>
      </Card>
    </div>
  );
};
